import { 
  TEpDevPSortDirection,
  EpDevPApiClientBase, 
  EpDevPPluginIds,
  EpDevPAsyncApiFormat,
  EpDevPAsyncApiVersion
} from '@solace-labs/backstage-plugin-ep-devp-common';
import {
  IEpDevPConsumerProductsApiClient,
  IEpDevPConsumerProduct,
  IEpDevPListConsumerProductsResponse,
} from './types';
import { EpDevPConsumerProductsApiPathsFactory } from './EpDevPConsumerProductsApiFactories';

export class EpDevPConsumerProductsApiClient extends EpDevPApiClientBase implements IEpDevPConsumerProductsApiClient {

  constructor(options: {
    discoveryApi: { getBaseUrl(pluginId: string): Promise<string> };
    fetchApi?: { fetch: typeof fetch };
  }) {
    super({ ...options, pluginId: EpDevPPluginIds.EpDevPConsumerProductsPluginId });
  }

  public async import({ organizationId }:{
    organizationId: string;
  }): Promise<IEpDevPListConsumerProductsResponse> {
    const epDevPListConsumerProductsResponse: IEpDevPListConsumerProductsResponse = await this.request({
      url: await this.createUrl(EpDevPConsumerProductsApiPathsFactory.createImportPath({
        organizationId: organizationId,
      })),
      method: 'GET',
    });

    // Print the response for import API call    
    return epDevPListConsumerProductsResponse;
  }

  public async list({ 
    organizationId, 
    domainIds,
    pageSize,
    pageNumber,
    searchTerm,
    sortDirection,
    sortFieldName
  }:{
    organizationId: string;
    domainIds?: Array<string>;
    pageSize?: number;
    pageNumber?: number;
    searchTerm?: string;
    sortDirection?: TEpDevPSortDirection;
    sortFieldName?: string;
  }): Promise<IEpDevPListConsumerProductsResponse> {
    const epDevPListConsumerProductsResponse: IEpDevPListConsumerProductsResponse = await this.request({
      url: await this.createUrl(EpDevPConsumerProductsApiPathsFactory.createListPath({
        organizationId: organizationId,
        domainIds: domainIds,
        pageSize: pageSize,
        pageNumber: pageNumber,
        searchTerm: searchTerm,
        sortDirection: sortDirection,
        sortFieldName: sortFieldName
      })),
      method: 'GET',      
    });

    //Added filter in product listing for static condition temprory, will change as required in future.
    // const filteredResults = epDevPListConsumerProductsResponse.list.filter(item => 
    //   item.customAttributeList.some(attr => 
    //       attr.entityId.id === "internalFlagId" && attr.value === "flag"
    //   )
    // );

    // epDevPListConsumerProductsResponse.list = filteredResults;
    // Print the response for list API call    
    return epDevPListConsumerProductsResponse;
  }

  public async byId({ organizationId, domainId, id, versionString }:{
    organizationId: string;
    domainId: string;
    id: string;
    versionString?: string;
  }): Promise<IEpDevPConsumerProduct> {
    const epDevPConsumerProduct: IEpDevPConsumerProduct = await this.request({
      url: await this.createUrl(EpDevPConsumerProductsApiPathsFactory.createConsumerProductByIdPath({
        organizationId: organizationId,
        domainId: domainId,
        eventApiProductId: id,
        versionString: versionString,
      })),
      method: 'GET'
    });

    // Print the response for byId API call
    return epDevPConsumerProduct;
  }

  public async byIdInternal({ organizationId, id, versionString }:{
    organizationId: string;
    id: string;
    versionString?: string;
  }): Promise<IEpDevPConsumerProduct> {
    const epDevPConsumerProduct: IEpDevPConsumerProduct = await this.request({
      url: await this.createUrl(EpDevPConsumerProductsApiPathsFactory.createConsumerProductByIdInternalPath({
        organizationId: organizationId,
        eventApiProductId: id,
        versionString: versionString,
      })),
      method: 'GET'
    });

    // Print the response for byIdInternal API call    
    return epDevPConsumerProduct;
  }

  public async asyncApi({ 
    organizationId, 
    domainId,
    eventApiProductId,
    eventApiId,
    planId, 
    format, 
    asyncApiVersion,
    fileNamePathForZip,
  }:{
    organizationId: string;
    domainId: string; 
    eventApiProductId: string;
    eventApiId: string;
    planId: string;
    format: EpDevPAsyncApiFormat;
    asyncApiVersion: EpDevPAsyncApiVersion;
    fileNamePathForZip?: string;
  }): Promise<any> {
    const asyncApi: any = await this.request({
      url: await this.createUrl(EpDevPConsumerProductsApiPathsFactory.createAsyncApiPath({
        organizationId: organizationId,
        domainId: domainId,
        eventApiProductId: eventApiProductId,
        eventApiId: eventApiId,
        planId: planId,
        format: format,
        asyncApiVersion: asyncApiVersion,
        fileNamePathForZip: fileNamePathForZip
      })),
      method: 'GET'
    });
    return asyncApi;
  }

}
